import React, { forwardRef, useImperativeHandle } from 'react';
import { PDFExport } from "@progress/kendo-react-pdf";
import dayjs from 'dayjs';

const PrintProductTemplate = forwardRef((props, ref) => {
  const { productData } = props;
  const userClaims = localStorage.getItem('UserClaims');

  let pdfExportComponent;
  const handlePrint = () => {
    pdfExportComponent && pdfExportComponent.save();
  };

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  useImperativeHandle(ref, () => ({
    handlePrint
  }));

  const pageTemplate = (props) => {
    return (
      <>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            fontSize: "18px",
            width: '100%',
            textAlign: 'center'
          }}
        >
          Page {props.pageNum} of {props.totalPages}
        </div>
      </>
    )
  }


  return (
    <>
      <PDFExport
        paperSize="A4"
        landscape={false}
        margin="2mm"
        scale={0.56}
        ref={(pdfExport) => (pdfExportComponent = pdfExport)}
        pageTemplate={pageTemplate}
        fileName='ProductList'
        repeatHeaders={true}
      >
        <section className='form-section'>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div >
              <div className='banner'>
                <img style={{ width: '100%' }} src='./items.png' />
                <div className='banner-content'>
                  <h4>{JSON.parse(userClaims)?.restaurent_name}</h4>
                  <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <h4>Products</h4>
                    <span style={{ color: '#a8a8a8' }}>|</span>
                    <h4>Printed: <span style={{ fontSize: '20px' }}>{dayjs().format('MM/DD/YYYY hh:mmA')}</span></h4>
                  </div>
                </div>
              </div>
              <div className='form-container'>
                <div className='form-body'>
                  {productData?.map((category, catIndex) => (
                    <div key={catIndex} style={{ marginTop: '20px' }}>
                      <div style={{ borderBottom: '1px solid #000' }}>
                        <h5 style={{ fontSize: '28px' }}>{category.CatName}</h5>
                      </div>
                      {category.subCategory.map((subCategory, subIndex) => (
                        <div key={subIndex} style={{ marginTop: '10px' }}>
                          <h4 style={{ fontSize: '20px' }}>{subCategory.SubCatName}</h4>

                          {subCategory.product.map((product, prodIndex) => (
                            <div key={prodIndex} style={{ marginBottom: '15px' }}>

                              {product.subProduct.map((subProduct, subProdIndex) => (
                                <div key={subProdIndex}>
                                  <div className="product-table-container">
                                    <table>
                                      <thead>
                                        <tr>
                                          <th>{product.Product} - {subProduct.SubProduct}</th>
                                          {/* <th>Qty</th> */}
                                          <th>Unit</th>
                                          <th>Price / Unit</th>
                                          <th>Pack</th>
                                          <th>Size / Pack</th>
                                          <th>Price / Pack</th>
                                          <th>Recently Purchased</th>
                                          <th>Location</th>
                                          {/* <th>Count</th>
                                          <th>Amount</th> */}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {subProduct.items.map((item, itemIndex) => (
                                          <tr key={itemIndex}>
                                            <td>{item.Name}</td>
                                            {/* <td>{item.Quantity}</td> */}
                                            <td>{item.Unit}</td>
                                            <td>{currencyFormatter.format(item.Price)}</td>
                                            <td>{item?.Pack}</td>
                                            <td>{item?.PackSize}</td>
                                            <td>{!!item?.PackPrice ? currencyFormatter.format(item.PackPrice) : "$0.00"}</td>
                                            <td>
                                              {item?.Inventory_date
                                                ? dayjs(item?.Inventory_date).format('MM/DD/YYYY')
                                                : ''
                                              }
                                            </td>
                                            <td>{item.location ?? "-"}</td>
                                            {/* <td>${(item.Price ? parseFloat(item.Price).toFixed(2) : "0.00")}</td> */}
                                            {/* <td>{item.Count ?? "-"}</td>
                                            <td>{item.Amount ?? "-"}</td> */}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

      </PDFExport>
    </>

  )
})
export default PrintProductTemplate;
